import { TableColumnsType } from "antd";
import { TableCustom } from "@components/table";
import { Dayjs } from "dayjs";
import { useHttpQuery } from "@/hooks";
import { salonActiveState } from "@/components/state";
import { useRecoilState } from "recoil";
import { getRevenueOfObjectTypeDetail, GetRevenueOfObjectTypeDetailResponse } from "@/api";
import { useMemo } from "react";
import { formatDateTime } from "@/utils";

export interface RevenueByObjectTypeDetailData {
    readonly id?: string;
    readonly name?: string;
    readonly revenue?: string;
    readonly quantity?: string;
    readonly discount?: string;
}

interface RevenueByObjectTypeDetailTableProps {
    readonly dateRange: [Dayjs, Dayjs];
    readonly objectType: "SERVICE" | "PRODUCT";
    readonly objectId: number;
}

export default function RevenueByObjectTypeDetailTable(props: RevenueByObjectTypeDetailTableProps) {
    const [salonActive] = useRecoilState(salonActiveState);

    const {data : revenueOfObjectTypeDetail, isFetching} = useHttpQuery(getRevenueOfObjectTypeDetail, {
        query: {
            startDate: formatDateTime(props.dateRange[0]),
            endDate: formatDateTime(props.dateRange[1]),
            objectType: props.objectType,
            objectId: props.objectId,
            salonId: salonActive?.id ?? 0
        }
    });

    const columns = useMemo<TableColumnsType<GetRevenueOfObjectTypeDetailResponse>>(
		() => [
			{
				title: 'Chi nhánh',
				dataIndex: 'salonBranchId',
				key: 'salonBranchId',
				render: (salonBranchId: number) =>
					salonActive?.salonBranches?.find((branch) => branch.id === salonBranchId)?.name,
			},
			{
				title: 'Số lượng',
				dataIndex: 'totalQuantity',
				key: 'totalQuantity',
			},
			{
				title: 'Doanh thu',
				dataIndex: 'totalRevenue',
				render: (value: number) => value.toLocaleString('en-US'),
				key: 'totalRevenue',
				width: 150,
			},
		],
		[salonActive?.salonBranches]
	);

    return (
        <div style={{ paddingTop: 20 }}>
            <TableCustom
                showHeader={false}
                columns={columns}
                dataSource={revenueOfObjectTypeDetail?.items}
                showFooter={false}
                loading={isFetching}
            />
        </div>
    )
}
